import { render, staticRenderFns } from "./GlobalRuleHeader.vue?vue&type=template&id=72e99bd6&scoped=true&"
import script from "./GlobalRuleHeader.vue?vue&type=script&lang=js&"
export * from "./GlobalRuleHeader.vue?vue&type=script&lang=js&"
import style0 from "./GlobalRuleHeader.vue?vue&type=style&index=0&id=72e99bd6&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72e99bd6",
  null
  
)

export default component.exports